import { CostCenterFromTo } from 'interfaces/CostCenterFromTo';
import {
  CostCenterFromToFilters,
  create,
  list,
  listAll,
  remove,
  retrieve,
  update,
} from './calls';
import { FieldValues, UseFormSetError } from 'react-hook-form';
import { handleErrorForm } from '..';
import { toValueLabel } from 'utils/object';

export default class CostcenterFromToApiCaller {
  static adaptFromAPI = (data: CostCenterFromTo) => {
    const costCenterFromTo = {
      ...data,
    };
    costCenterFromTo.toId = toValueLabel(data.toId as string);

    return costCenterFromTo as FieldValues;
  };

  static adaptToAPI = (data: FieldValues) => {
    const costCenterFromTo = {
      ...data,
    };

    costCenterFromTo.to = (data.to as FieldValues)?.label;

    return costCenterFromTo as CostCenterFromTo;
  };

  static list = async (filters: CostCenterFromToFilters) => {
    const {
      data: { costCenters },
    } = await list(filters);

    return {
      ...costCenters,
      result: costCenters.result,
    };
  };

  static listAll = async () => {
    const {
      data: { costCentersAll },
    } = await listAll();

    return {
      ...costCentersAll,
      result: costCentersAll.result,
    };
  };

  static fetchCostCenterFromTo = async (id: string) => {
    const { data } = await retrieve(id);
    return data;
  };

  static createOrUpdate = async <T extends FieldValues>(
    data: T,
    setError: UseFormSetError<T>
  ) => {
    const method = data.id ? update : create;

    const result = method(this.adaptToAPI(data)).catch(
      handleErrorForm(setError)
    );

    return result;
  };

  static remove = async (id: string) => {
    const { data } = await remove(id);

    return data;
  };
}
